import { render, staticRenderFns } from "./updateUserName.vue?vue&type=template&id=5dd315b6"
import script from "./updateUserName.vue?vue&type=script&lang=js"
export * from "./updateUserName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd315b6')) {
      api.createRecord('5dd315b6', component.options)
    } else {
      api.reload('5dd315b6', component.options)
    }
    module.hot.accept("./updateUserName.vue?vue&type=template&id=5dd315b6", function () {
      api.rerender('5dd315b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemModule/accountSetting/components/updateUserName.vue"
export default component.exports